import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PATHS } from './paths';

import PostManagement from '../Page/PostManagement';
import DonorManagement from '../Page/DonorManagement';
import PaymentStatus from '../Page/PaymentStatus';
import ProjectManagement from '../Page/ProjectManagement/index';
import ProjectSettings from '../Page/ProjectSettings';
import NewProject from '../Page/NewProject';
import MyAccount from '../Page/MyAccount';
import GivingAccountApply from '../Page/GivingAccountApply';
import Login from '../Page/Login';
import SsoCallback from '../Page/SsoCallback';
import SnsCallback from '../Page/SnsCallback';
import Signup from '../Page/Signup';
import PasswordFind from '../Page/PasswordFind';
import DonationHistoryFind from '../Page/DonationHistoryFind';
import AuthGuard from './AuthGuard';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={PATHS.LOGIN} element={<Login />} />
      {/* 임시 안내용: 카카오 로그인 없이 이메일·비밀번호로 로그인 (로그인 화면에서 링크하지 않는다) */}
      <Route path={PATHS.LOGIN_EMAIL} element={<Login emailOnly />} />
      <Route path={PATHS.SSO_CALLBACK} element={<SsoCallback />} />
      <Route path={PATHS.SNS_KAKAO_CALLBACK} element={<SnsCallback />} />
      <Route path={PATHS.PASSWORD_FIND} element={<PasswordFind />} />
      <Route path={PATHS.DONATION_HISTORY_FIND} element={<DonationHistoryFind />} />
      <Route path={PATHS.SIGNUP} element={<Signup />} />

      {/* Protected Routes */}
      <Route element={<AuthGuard />}>
        <Route path={PATHS.DASHBOARD} element={<Navigate to={PATHS.PROJECT_MANAGEMENT} replace />} />
        <Route path={PATHS.POST_MANAGEMENT} element={<PostManagement />} />
        <Route path={PATHS.DONOR_MANAGEMENT} element={<DonorManagement />} />
        <Route path={PATHS.PAYMENT_STATUS} element={<PaymentStatus />} />
        <Route path={PATHS.PROJECT_MANAGEMENT} element={<ProjectManagement />} />
        <Route path={PATHS.PROJECT_SETTINGS} element={<ProjectSettings />} />
        <Route path={PATHS.NEW_PROJECT} element={<NewProject />} />
        <Route path={PATHS.MY_ACCOUNT} element={<MyAccount />} />
        <Route path={PATHS.GIVING_ACCOUNT_APPLY} element={<GivingAccountApply />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;


